// extracted by mini-css-extract-plugin
export default {"mainTitle":"ProductList_mainTitle__7wQ+j"};